/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable camelcase */
import { auth, db, functions } from '@/shared/services/firebase'
import axios from '@hw-core/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRequests(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        const {
          status, perPage,
        } = queryParams
        let { list } = queryParams

        let query = db.collection('clientRequests').where('type', '==', 'quick_shifts_confirmation').orderBy('createdAt', 'desc')
        if (status === 'active') {
          query = query.where('status', 'in', ['open', 'pending'])
        }
        if (status === 'closed') {
          query = query.where('status', '==', status)
        }

        if (list.length >= perPage) {
          query = query.startAfter(list[list.length - 1].createdAt)
        } else {
          list = []
        }

        query.limit(perPage)
          .get()
          .then(async snapshot => {
            const data = snapshot.docs.map(doc => {
              const item = doc.data()
              item.id = doc.id
              return item
            })
            list.push(...data)
            resolve({ data: list, isMore: data.length >= perPage })
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    fetchRequest(ctx, { id }) {
      return new Promise((resolve, reject) => {
        db.collection('clientRequests')
          .doc(id)
          .get()
          .then(doc => {
            if (!doc.exists) { resolve(null) }
            resolve(doc.data())
          })
          .catch(() => {
            reject()
          })
      })
    },

    async fetchShiftsByRequestId(ctx, { type, id }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts')
          .where(type, '==', id)
          .get()
          .then(async snapshot => {
            const shifts = await Promise.all(snapshot.docs.map(async doc => {
              const shift = { ...doc.data(), id: doc.id }
              const user = await db.collection('users').doc(shift.assignedTo).get()
              const area = await db.collection('areas').doc(shift.areaId).get()
              const gig = await db.collection('gigs').doc(shift.gigId).get()
              return {
                ...shift,
                user: user.exists ? user.data() : null,
                area: area.exists ? area.data() : { name: '' },
                gig: gig.exists ? gig.data() : null,
              }
            }))
            resolve(shifts)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    sendSMS(ctx, { mobile, message }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${functions.url}/sendSMSMessage`, { to: mobile, message, token: idToken })
            .then(response => resolve(response))
            .catch(error => reject(error))
        }).catch(error => {
          reject(error)
        })
      })
    },

    sendVerificationEmail(ctx, { to, message, subject }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${functions.url}/sendEmail`, { to, message, subject })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    createZendeskTicket(ctx, {
      requester, groupId, message, subject, collaborators,
    }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${functions.url}/createZendeskTicket`, {
              requester, groupId, message, subject, collaborators, token: idToken,
            })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
          .catch(error => {
            reject(error)
          })
      })
    },

    updateZendeskTicket(ctx, {
      requester, ticketId, message, collaborators,
    }) {
      return new Promise((resolve, reject) => {
        auth.currentUser.getIdToken(true).then(idToken => {
          axios
            .post(`${functions.url}/updateZendeskTicket`, {
              requester, ticketId, message, collaborators, token: idToken,
            })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
          .catch(error => {
            reject(error)
          })
      })
    },

    updateClientRequest(ctx, { id, updates }) {
      return new Promise((resolve, reject) => {
        db.collection('clientRequests').doc(id).update({
          ...updates,
        })
          .then(() => {
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    updateShift(ctx, { id, updates }) {
      return new Promise((resolve, reject) => {
        db.collection('shifts').doc(id).update({ ...updates }).then(() => {
          resolve()
        })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
}
